import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { HealthPlanResponse } from '@/modules/deductibles/deductibles.types.ts';

export const QUERY_KEY = 'HEALTH_PLAN_BY_ID';
export const useHealthPlanByIdQuery = (id?: string, successCallback?: (plan: HealthPlanResponse) => void) => {
  const { isLoading, error, data, isSuccess, isError } = useQuery(
    [QUERY_KEY, id],
    id ? () => api.get<HealthPlanResponse>(API_URL.HEALTH_PLANS_BY_ID(id)) : () => null,
    {
      onSuccess: (response) => {
        if (successCallback && response) {
          successCallback(response.data);
        }
        return response;
      },
      cacheTime: 10,
      refetchOnMount: false,
    }
  );

  return {
    data: data?.data,
    error,
    isError,
    isLoading,
    isSuccess,
  };
};

export default useHealthPlanByIdQuery;
